import React from 'react';

import { Typography } from '@mui/material';
import type { GridCellParams } from '@mui/x-data-grid-premium';
import { Circle } from 'lucide-react';
import type { ReminderListRow } from 'src/components/reminders/ColumnDef';
import { Apollo } from 'src/gql/generated';
import { makeStyles } from 'tss-react/mui';

import { getReminderTypeColor } from '../details/ReminderType';

const useStyles = makeStyles()(theme => ({
  row: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
  },
}));

export function ReminderTypeCell({
  value = Apollo.ReminderType.Expiration,
}: GridCellParams<ReminderListRow, ReminderListRow['type']>) {
  const { classes } = useStyles();
  const color = getReminderTypeColor(value);

  return (
    <div className={classes.row}>
      <Circle color={color} fill={color} size={12} />
      <Typography>{value}</Typography>
    </div>
  );
}
